module.exports = __webpack_public_path__ + "uz.0b355e68a214eb9c063d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/uz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/uz.svg
// module chunks = styles